module.exports = __webpack_public_path__ + "img/What_Would_You_Do.28f95e1c.jpg";